<template>
  <div class="footer-container">
      <div class="footer-content width-max">
            <div class="footer-main">

                <img src="@/assets/logo/logo_png8.png" height=200 width=121 alt="DOF logo">
                
                <!-- contact is moved to last position on large screens -->
                <div class=contact>
                    <span class="contact-title">Kontakt</span>
                    <div class="text-p1">
                        <p>DOF BirdLife</p>
                        <p>Vesterbrogade 140</p>
                        <p>1620 København V</p>
                    </div>
                    <div class="text-p2">
                        <p>Tlf. +45 3328 3800</p>
                        <p>E-mail: dof@dof.dk</p>
                    </div>
                </div>

                <div class="social-media">
                    <div class="social-media-icons">                
                        <a href="https://www.facebook.com/BirdLifeDanmark/" aria-label="Besøg os på facebook"><i class="fab fa-facebook-square"></i></a>
                        <a href="https://www.instagram.com/danmarksfugle/" aria-label="Besøg os på instagram"><i class="fab fa-instagram-square"></i></a>
                        <a href="https://twitter.com/birdlifedanmark" aria-label="Besøg os på twitter"><i class="fab fa-twitter-square"></i></a>
                    </div>

                    <div class="web-link">
                        <a href="https://www.dof.dk/">www.dof.dk</a>
                    </div>
                </div>

            </div>

      </div>
  </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            //css
            headerHeight: 200,
            headerHeightCSS: '190px'
        }
    }
}
</script>

<style scoped>
.footer-container {
    width: 100%;
    background: #eee;
    padding: 2em 0 2em 0;
}

.footer-content {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.footer-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.footer-main img {
    cursor: pointer;
}
.footer-main p {
    color: #555;
}

.contact {
    height: v-bind(headerHeightCSS);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-self: end;
    order: 1;
}
.contact .contact-title{
    font-weight: 500;
    font-size: 1.5rem;
    text-transform: uppercase;
    color: #333;
}
.contact .text-p1 {
    padding-bottom: 1.5rem;
}
.social-media {
    align-self: end;
    position: relative;
}
.social-media-icons {
    padding: 0em 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.web-link {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1rem 0;
}

a {
    text-decoration: none;
    color: #555;
}
.social-media-icons > * + * {
    margin-left: 1.3em;
}
.social-media-icons i {
    font-size: 2rem;
    color: #555;
    cursor: pointer;
}
.social-media-icons p {
    color: #555;
    cursor: pointer;
}
.footer-content h4 {
    text-transform: uppercase;
}

@media screen and (max-width: 600px) {
    .footer-main {
        flex-wrap: wrap;

    }
    .contact {
        order: 0;
    }
    .social-media {
        flex-basis: 100%;
        padding-top: 1em;
    }
}

@media screen and (max-width: 370px) {
    .footer-main {
        /*flex-direction: column;*/
        flex-wrap: wrap;
        justify-content: center;
    }
    .contact {
        flex-basis: 100%;
        padding-top: 2em;
        align-items: center;
    }
    .contact .contact-title{
        padding-bottom: 0.5em;
    }
    .social-media {
        flex-basis: 100%;
        padding-top: 3.3em;
    }
}

</style>